(() => {
  const key = 'raRyzoPhotoHintSeenV1';
  const text = document.getElementById('ra-ryzo-premium-config')?.dataset.photoHint;
  if (!text) return;
  let done = false;
  let due = null;
  let showTimer = null;
  let hideTimer = null;
  let hint = null;
  let launcher = null;
  const readDone = () => {
    try { return sessionStorage.getItem(key) === '1'; } catch (_) { return done; }
  };
  done = readDone();
  const finish = (consume = false) => {
    if (consume) {
      done = true;
      try { sessionStorage.setItem(key, '1'); } catch (_) {}
    }
    clearTimeout(showTimer);
    clearTimeout(hideTimer);
    showTimer = null;
    hideTimer = null;
    if (hint) {
      hint.hidden = true;
      hint.textContent = '';
    }
  };
  const place = () => {
    if (!hint || !launcher) return;
    const rect = launcher.getBoundingClientRect();
    const width = document.documentElement.clientWidth;
    const left = rect.left - 24;
    const right = width - rect.right - 24;
    const side = left >= 178 || left >= right ? 'left' : 'right';
    hint.dataset.side = side;
    hint.style.width = Math.min(178, Math.max(90, side === 'left' ? left : right)) + 'px';
  };
  const show = () => {
    showTimer = null;
    if (done || readDone()) { finish(); return; }
    if (document.hidden) return;
    if (!launcher?.isConnected || launcher.dataset.raState !== 'ready') { finish(true); return; }
    if (document.querySelector('.ryzo-modal-overlay')) { finish(true); return; }
    done = true;
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
    place();
    hint.textContent = text;
    hint.hidden = false;
    hideTimer = setTimeout(() => finish(), 3000);
  };
  const arm = () => {
    if (done || due === null || !launcher || showTimer !== null || document.hidden) return;
    showTimer = setTimeout(show, Math.max(0, due - Date.now()));
  };
  const mount = () => {
    if (document.querySelector('.ryzo-modal-overlay')) { finish(true); return; }
    const next = document.querySelector('.ra-ryzo-launcher');
    if (!next) return;
    if (next.dataset.raState === 'closed') { finish(true); return; }
    if (next !== launcher) {
      launcher = next;
      hint = document.createElement('span');
      hint.className = 'ra-ryzo-photo-hint';
      hint.hidden = true;
      hint.setAttribute('role', 'status');
      hint.setAttribute('aria-live', 'polite');
      hint.setAttribute('aria-atomic', 'true');
      launcher.appendChild(hint);
      new MutationObserver(() => {
        if (launcher.dataset.raState === 'closed' || launcher.dataset.raDragging === 'true') finish(true);
        else if (hint && !hint.hidden) place();
      }).observe(launcher, { attributes: true, attributeFilter: ['style', 'data-ra-state', 'data-ra-dragging'] });
    }
    arm();
  };
  document.addEventListener('pointerdown', (event) => {
    if (event.target.closest?.('#float-image-icon, .ra-ryzo-dismiss')) finish(true);
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest?.('#float-image-icon, .ra-ryzo-dismiss')) finish(true);
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.target.closest?.('#float-image-icon') && /^(Enter| |Arrow)/.test(event.key)) finish(true);
  }, true);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && hint && !hint.hidden) finish();
    else arm();
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && readDone()) { done = true; finish(); }
  });
  window.addEventListener('resize', place, { passive: true });
  const loaded = () => { due = Date.now() + 10000; mount(); };
  new MutationObserver(mount).observe(document.body, { childList: true, subtree: true });
  mount();
  if (document.readyState === 'complete') loaded();
  else window.addEventListener('load', loaded, { once: true });
})();
